import { Col, Form, Row } from "react-bootstrap";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  Typography,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useState } from "react";
import { ColDef } from "ag-grid-enterprise";
import CloseIcon from "@mui/icons-material/Close";
import { useDropzone } from "react-dropzone";
import { useLocation, useNavigate } from "react-router-dom";
import {
  GetMetadataOrderdefinition,
  SaveAndSubmit,
} from "../../api/preworkDetailApi/preworkDetailApi";
import { urlConfig } from "../../config/urlConfig";
import { useSnackbar } from "../Common/SnackbarContext";
import { useLoader } from "../../context/LoaderContext";
import LocalStorageUtil from "../../utils/localStorage";

interface DynamicData {
  mappingAutoId: number;
  fieldName: string;
  type: string;
  data: any;
  defaultValue: string;
  ValidationMessage: string;
}

interface TempValue {
  MappingId: number;
  name: string;
  data: string;
  Dropdowndata: any;
}

const Upload = () => {
  const { showSnackbar } = useSnackbar();
  const [rowData, setRowData] = useState<any[]>([]);
  const { setLoading } = useLoader();
  const [validationMessage, setValidationMessage] = useState<string | null>(
    null
  );
  const [inputOptions, setInputOptions] = useState("1");
  const [projectId, setProjectId] = useState("");
  const [projectDescription, setProjectDescription] = useState("");
  const [projectManager, setProjectManager] = useState("");
  const [supplierTrackingId, setSupplierTrackingId] = useState("");
  const [workOrderSubmittedDate, setWorkOrderSubmittedDate] =
    useState<Date | null>(new Date());
  const [supplierDueDate, setSupplierDueDate] = useState("");
  const [comment, setComment] = useState("");
  const [workArea, setWorkArea] = useState("");
  const [errors, setErrors] = useState<{
    workAreaError: string | null;
    projectManagerError: string | null;
  }>({
    workAreaError: null,
    projectManagerError: null,
  });
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const [responseData, setResponseData] = useState<any[]>([]);
  const navigate = useNavigate();
  let selectedFiles: File[] = [];
  const [uploadedFiles, setFiles] = useState<File[] | null>(null); // NOSONAR
  const dynamicdata: DynamicData[] = []; // Replace with actual data
  const Dynamicobject: TempValue[] = [];
  const [workAreaId, setWorkAreaId] = useState<number | null>(null);
  const location = useLocation();
  let screenType = location?.state?.["screen"];
  //Fetch data from API on page load
  useEffect(() => {
    setProjectManager(
      LocalStorageUtil.getItem("firstName") +
        " " +
        LocalStorageUtil.getItem("lastName")
    );
    getData();
  }, []);

  //Action Cell Renderer
  const actionCellRenderer = (params: any) => {
    if (params.data === undefined) {
      return "";
    } else {
      return (
        <a href="#" style={{ color: "var(--aggrid-text-color)" }}>
          <CloseIcon
            onClick={() => handleDeleteRow(params.data.fileName)}
            data-testid="close-icon"
          />
        </a>
      );
    }
  };

  //Defined grid column
  const [columnDef] = useState<ColDef[]>([
    {
      headerName: "File Name",
      field: "fileName",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "File Size",
      field: "fileSize",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Action",
      field: "action",
      width: 110,
      sortable: false,
      resizable: false,
      cellRenderer: actionCellRenderer,
    },
  ]);

  //Handle delete row
  const handleDeleteRow = (fileName: string) => {
    setRowData((prevRowData) =>
      prevRowData.filter((row) => row.fileName !== fileName)
    );
  };

  //Handle select files using open file dialog box
  const handelSelectFiles = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      if (inputOptions === "1") {
        selectedFiles = Array.from(files).filter(
          (file) =>
            file.name.toLowerCase().endsWith(".xls") ||
            file.name.toLowerCase().endsWith(".xlsx") ||
            file.name.toLowerCase().endsWith(".zip")
        );
      } else if (inputOptions === "2") {
        selectedFiles = Array.from(files).filter(
          (file) =>
            file.name.toLowerCase().endsWith(".xls") ||
            file.name.toLowerCase().endsWith(".xlsx") ||
            file.name.toLowerCase().endsWith(".pdf") ||
            file.name.toLowerCase().endsWith(".zip")
        );
      } else if (inputOptions === "3" || inputOptions === "4") {
        selectedFiles = Array.from(files).filter(
          (file) =>
            file.name.toLowerCase().endsWith(".pdf") ||
            file.name.toLowerCase().endsWith(".zip")
        );
      }

      const newRowData = selectedFiles.map((file) => ({
        fileName: file.name,
        fileSize: file.size,
        fileType: file.type,
      }));
      if (newRowData.length > 0) {
        setRowData((prevRowData) => [...prevRowData, ...newRowData]);
        setFiles(Array.from(files));
        setValidationMessage(null);
      } else if (inputOptions === "1") {
        setValidationMessage("Please select valid file types(.xls,.xlsx,.zip)");
      } else if (inputOptions === "2" || inputOptions === "3") {
        setValidationMessage("Please select valid file types(.pdf,.zip)");
      } else {
        setValidationMessage(
          "Please select valid file types(.xls,.xlsx,.pdf,.zip)"
        );
      }
      event.target.value = "";
    }
  };

  //#region Drag and drop file upload
  const onDrop = (files: any) => {
    let excelFiles = files;
    if (inputOptions === "1") {
      excelFiles = files.filter(
        (file: any) =>
          file.name.toLowerCase().endsWith(".xls") ||
          file.name.toLowerCase().endsWith(".xlsx") ||
          file.name.toLowerCase().endsWith(".zip")
      );
    } else if (inputOptions === "2") {
      excelFiles = files.filter(
        (file: any) =>
          file.name.toLowerCase().endsWith(".xls") ||
          file.name.toLowerCase().endsWith(".xlsx") ||
          file.name.toLowerCase().endsWith(".pdf") ||
          file.name.toLowerCase().endsWith(".zip")
      );
    } else if (inputOptions === "3" || inputOptions === "4") {
      excelFiles = files.filter(
        (file: any) =>
          file.name.toLowerCase().endsWith(".pdf") ||
          file.name.toLowerCase().endsWith(".zip")
      );
    }

    const newRowData = excelFiles.map((file: any) => ({
      fileName: file.name,
      fileSize: file.size,
      fileType: file.type,
    }));
    if (newRowData.length > 0) {
      setRowData((prevRowData) => [...prevRowData, ...newRowData]);
      setFiles(Array.from(files || []));
      setValidationMessage(null);
    } else if (inputOptions === "1") {
      setValidationMessage("Please select valid file types(.xls,.xlsx,.zip)");
    } else if (inputOptions === "2" || inputOptions === "3") {
      setValidationMessage("Please select valid file types(.pdf,.zip)");
    } else {
      setValidationMessage(
        "Please select valid file types(.xls,.xlsx,.pdf,.zip)"
      );
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
      "application/pdf": [".pdf"],
    },
  });

  //#endregion

  // Handle Save and Submit button click
  const handelSaveAndSubmitClick = async () => {
    const newErrors: {
      workAreaError: string | null;
      projectManagerError: string | null;
    } = {
      workAreaError: null,
      projectManagerError: null,
    };

    setErrors({
      workAreaError: null,
      projectManagerError: null,
    });

    if (!workArea) {
      newErrors.workAreaError = "Work Area is required";
    } else if (!projectManager) {
      newErrors.projectManagerError = "Project Manager is required";
    } else if (rowData.length === 0) {
      setValidationMessage("Please select file(s)");
      return;
    }

    if (Object.values(newErrors).some((error) => error !== null)) {
      setErrors(newErrors);
      return;
    }
    //Api call to save data
    SaveData(1);
  };

  //Handle Save and Accept button click
  const handleSaveAndAcceptClick = async () => {
    const newErrors: {
      workAreaError: string | null;
      projectManagerError: string | null;
    } = {
      workAreaError: null,
      projectManagerError: null,
    };

    setErrors({
      workAreaError: null,
      projectManagerError: null,
    });
    if (!workArea) {
      newErrors.workAreaError = "Work Area is required";
    } else if (!projectManager) {
      newErrors.projectManagerError = "Project Manager is required";
    } else if (rowData.length === 0) {
      setValidationMessage("Please select file(s)");
      return;
    }

    if (Object.values(newErrors).some((error) => error !== null)) {
      setErrors(newErrors);
      return;
    }
    //Api call to save data
    SaveData(2);
  };

  // Helper function to get input option label
  const getInputOptionLabel = (inputOptions: string): string => {
    const optionMap: Record<string, string> = {
      "1": "DMF",
      "2": "DMF & PDF",
      "3": "PDF",
      "4": "To Final Folder",
    };
    return optionMap[inputOptions] || "";
  };

  // Helper function to get field data value
  const getFieldDataValue = (
    fieldName: string,
    responseItem: any,
    state: {
      inputOptions: string;
      projectId: string;
      projectDescription: string;
      projectManager: string;
      supplierTrackingId: string;
      workOrderSubmittedDate: Date | null;
      supplierDueDate: string;
      comment: string;
      workAreaId: number | null;
    }
  ): string => {
    const fieldValueMap: Record<string, () => string> = {
      "Input Options": () =>
        responseItem.type === "select"
          ? getInputOptionLabel(state.inputOptions)
          : "",
      "Project ID": () => state.projectId || "",
      "Project Description": () => state.projectDescription || "",
      "Project Manager": () => state.projectManager || "",
      "Supplier Tracking ID": () => state.supplierTrackingId || "",
      "Work Order Submitted Date": () =>
        state.workOrderSubmittedDate
          ? state.workOrderSubmittedDate.toISOString()
          : "",
      "Supplier Due Date": () => state.supplierDueDate || "",
      Comments: () => state.comment || "",
      "Work Area": () => state.workAreaId?.toString() ?? "",
    };

    const getValue = fieldValueMap[fieldName];
    return getValue ? getValue() : "";
  };

  // Helper function to get dropdown data value
  const getDropdownDataValue = (
    fieldName: string,
    state: {
      projectId: string;
      projectDescription: string;
      projectManager: string;
      supplierTrackingId: string;
      workOrderSubmittedDate: Date | null;
      supplierDueDate: string;
      comment: string;
      workArea: string;
      workAreaId: number | null;
    }
  ): any => {
    const dropdownMap: Record<string, () => any> = {
      "Project ID": () => state.projectId,
      "Project Description": () => state.projectDescription,
      "Project Manager": () => state.projectManager,
      "Supplier Tracking ID": () => state.supplierTrackingId,
      "Work Order Submitted Date": () => state.workOrderSubmittedDate,
      "Supplier Due Date": () => state.supplierDueDate,
      Comments: () => state.comment,
      "Work Area": () =>
        JSON.stringify({ id: state.workArea, name: state.workAreaId }),
    };

    const getValue = dropdownMap[fieldName];
    return getValue ? getValue() : null;
  };

  // Helper function to build temp value object
  const buildTempValue = (
    responseItem: any,
    state: {
      inputOptions: string;
      projectId: string;
      projectDescription: string;
      projectManager: string;
      supplierTrackingId: string;
      workOrderSubmittedDate: Date | null;
      supplierDueDate: string;
      comment: string;
      workArea: string;
      workAreaId: number | null;
    }
  ): TempValue => {
    return {
      MappingId: responseItem.mappingAutoId,
      name: responseItem.fieldName,
      data: getFieldDataValue(responseItem.fieldName, responseItem, state),
      Dropdowndata: getDropdownDataValue(responseItem.fieldName, state),
    };
  };

  // Helper function to get file format based on input option
  const getFileFormat = (inputOptions: string): string => {
    const formatMap: Record<string, string> = {
      "1": ".xls,.xlsx",
      "2": ".xls,.xlsx,.pdf",
      "3": ".pdf",
      "4": ".pdf",
    };
    return formatMap[inputOptions] || ".xls,.xlsx,.pdf";
  };

  // Helper function to build dynamic objects
  const buildDynamicObjects = (
    responseData: any[],
    state: {
      inputOptions: string;
      projectId: string;
      projectDescription: string;
      projectManager: string;
      supplierTrackingId: string;
      workOrderSubmittedDate: Date | null;
      supplierDueDate: string;
      comment: string;
      workArea: string;
      workAreaId: number | null;
    }
  ): TempValue[] => {
    return responseData.map((responseItem) =>
      buildTempValue(responseItem, state)
    );
  };

  // Helper function to build form data
  const buildFormData = (
    dynamicObjects: TempValue[],
    uploadedFiles: File[] | null,
    state: {
      inputOptions: string;
      projectId: string;
      projectDescription: string;
      workOrderSubmittedDate: Date | null;
      supplierDueDate: string;
      workArea: string;
    },
    actionType: number
  ): FormData => {
    const formData = new FormData();

    // Append basic fields
    formData.append("paramGetUrl", urlConfig.UploadToServer);
    formData.append("DynamicInputType", state.inputOptions);
    formData.append("InputType", state.inputOptions);
    formData.append("ProjectReference", state.projectId);
    formData.append(
      "WorkOrderSubmittedDate",
      String(state.workOrderSubmittedDate)
    );
    formData.append("SupplierDueDate", state.supplierDueDate);
    formData.append("WorkArea", state.workArea);
    formData.append(
      "AccountId",
      String(Number(LocalStorageUtil.getItem("accountId")))
    );
    formData.append(
      "CreatedBy",
      String(Number(LocalStorageUtil.getItem("userId")))
    );
    formData.append("FileFormat", getFileFormat(state.inputOptions));
    formData.append(
      "contextName",
      String(LocalStorageUtil.getItem("contextName"))
    );
    formData.append("QueueType", "1");
    formData.append("DocumentStatusId", String(actionType));
    formData.append("ProjectDocumentId", "");
    formData.append("DocumentDescription", state.projectDescription);
    formData.append("SaveandAccept", String(actionType !== 1));

    // Append files
    if (uploadedFiles) {
      Array.from(uploadedFiles).forEach((file) => {
        formData.append("files", file);
      });
    }

    // Append dynamic fields
    formData.append("Fields", JSON.stringify(dynamicObjects));

    return formData;
  };

  // Refactored SaveData function
  const SaveData = async (actionType: number) => {
    try {
      setLoading(true);

      // Build dynamic objects from response data
      const dynamicObjects = buildDynamicObjects(responseData, {
        inputOptions,
        projectId,
        projectDescription,
        projectManager,
        supplierTrackingId,
        workOrderSubmittedDate,
        supplierDueDate,
        comment,
        workArea,
        workAreaId,
      });

      // Build form data
      const formData = buildFormData(
        dynamicObjects,
        uploadedFiles,
        {
          inputOptions,
          projectId,
          projectDescription,
          workOrderSubmittedDate,
          supplierDueDate,
          workArea,
        },
        actionType
      );

      // Submit form data
      const response = await SaveAndSubmit(formData);
      if (response) {
        showSnackbar("File successfully uploaded");
        navigate("/preworkdetails");
      }
    } catch (error) {
      console.error("Error in SaveData ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleProjectIdChange = (event: any) => {
    if (event.target.value.length > 0) {
      setProjectId(event.target.value);
    } else {
      setProjectId("");
    }
  };
  //Handle Project Manager change
  const onChangeProjectManeger = (event: any) => {
    if (event.target.value.length > 0) {
      setErrors({ ...errors, projectManagerError: null });
      setProjectManager(event.target.value);
    } else {
      setErrors({
        ...errors,
        projectManagerError: "Project Manager is required",
      });
    }
  };

  //Handle Work Area change
  const handleWorkAreaChange = (event: any) => {
    const { value } = event.target;
    const selectedOption = event.target.options[event.target.selectedIndex];
    const workAreaId = selectedOption ? selectedOption.innerText : null;
    setWorkArea(value);
    setWorkAreaId(workAreaId);
    setErrors({ ...errors, workAreaError: null });
  };

  //Handle Cancel button click
  const handelCancel = () => {
    setConfirmDialogOpen(true);
  };

  //Close the dialog box after confirmation
  const handleConfirmDialogClose = (confirm: boolean) => {
    setConfirmDialogOpen(false);
    if (confirm) {
      // Add your logic here if needed
      if (screenType === "preworksummary") {
        navigate("/summary");
      } else {
        navigate("/preworkdetails");
      }
    } else {
      setConfirmDialogOpen(false);
    }
  };

  //Handle Input Option change
  const handelInputOptionChange = (event: any) => {
    selectedFiles = [];
    setRowData([]);
    const { value } = event.target;
    setInputOptions(value);
  };

  // Data fetch from API
  const getData = async () => {
    try {
      setLoading(true);
      const params = {
        AccountId: Number(LocalStorageUtil.getItem("accountId")),
        MetadataDefinitionId: Number(
          LocalStorageUtil.getItem("metadatadefinitionId")
        ),
        contextName: LocalStorageUtil.getItem("contextName"),
      };
      debugger;
      const response = await GetMetadataOrderdefinition(params);
      if (response) {
        setResponseData(response);
      }
    } catch (error) {
      console.error("Error in getData ", error);
    } finally {
      setLoading(false);
    }
  };

  // Render the component
  return (
    <div>
      <NavigationBar
        title="Queue Management > Prework Detail > Upload New"
        text="Upload New"
      />
      <Row style={{ margin: "10px" }}>
        <Col xs={12}>
          <div className="rp-main-inner full-width100">
            <div className="form-inp col-sm-12">
              <h4
                className="form-heading"
                style={{ color: "var(--aggrid-text-color)", fontSize: "12px" }}
              >
                DOCUMENT MANAGEMENT FORM
              </h4>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Form>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Input Options
                        </Form.Label>
                        <Form.Select
                          defaultValue={2}
                          value={inputOptions}
                          onChange={handelInputOptionChange}
                          style={{ fontSize: "11px" }}
                        >
                          <option value={1}>DMF</option>
                          <option value={2}>DMF & PDF</option>
                          <option value={3}>PDF</option>
                          <option value={4}>To Final Folder</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Project ID
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Project ID"
                          name="projectId"
                          value={projectId}
                          onChange={handleProjectIdChange}
                          style={{ fontSize: "11px" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Project Description
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          placeholder="Enter Project Description"
                          name="projectDescription"
                          rows={3}
                          value={projectDescription}
                          onChange={(e) =>
                            setProjectDescription(e.target.value)
                          }
                          style={{ fontSize: "11px" }}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.projectManagerError}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Project Manager *
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Project Manager"
                          name="projectManager"
                          required
                          value={projectManager}
                          onChange={onChangeProjectManeger}
                          isInvalid={!!errors.projectManagerError}
                          style={{ fontSize: "11px" }}
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          style={{ color: "var(--text-color)" }}
                        >
                          {errors.projectManagerError}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col ms={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Supplier Tracking ID
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Supplier ID"
                          name="supplierTrackingId"
                          value={supplierTrackingId}
                          onChange={(e) =>
                            setSupplierTrackingId(e.target.value)
                          }
                          style={{ fontSize: "11px" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col ms={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Work Order Submitted Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          placeholder="Enter Supplier Name"
                          name="workOrderSubmittedDate"
                          value={
                            workOrderSubmittedDate
                              ? workOrderSubmittedDate
                                  .toISOString()
                                  .split("T")[0]
                              : ""
                          }
                          onChange={(e) =>
                            setWorkOrderSubmittedDate(new Date(e.target.value))
                          }
                          style={{ fontSize: "11px" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col ms={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Supplier Due Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          placeholder="Enter Supplier Name"
                          name="supplierDueDate"
                          value={supplierDueDate}
                          onChange={(e) => setSupplierDueDate(e.target.value)}
                          style={{ fontSize: "11px" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Comment
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          placeholder="Enter comment"
                          name="comment"
                          rows={3}
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                          style={{ fontSize: "11px" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </Box>
              <h4
                className="form-heading"
                style={{ color: "var(--aggrid-text-color)", fontSize: "12px" }}
              >
                ENTER INPUT PARAMETERS
              </h4>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Form>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Work Area *
                        </Form.Label>
                        <Form.Select
                          data-testid="work-area-select"
                          value={workArea}
                          onChange={handleWorkAreaChange}
                          isInvalid={!!errors.workAreaError}
                          style={{ fontSize: "11px" }}
                        >
                          <option value={0}>Select</option>
                          <option value={1}>Work Area 1</option>
                          <option value={2}>Work Area 2</option>
                          <option value={3}>Work Area 3</option>
                          <option value={4}>Work Area 4</option>
                          <option value={5}>Work Area 5</option>
                          <option value={6}>Work Area 6</option>
                          <option value={7}>Work Area 7</option>
                          <option value={8}>Work Area 8</option>
                          <option value={9}>Work Area 9</option>
                          <option value={10}>Work Area 10</option>
                        </Form.Select>
                        <Form.Control.Feedback
                          type="invalid"
                          style={{ color: "var(--text-color)" }}
                        >
                          {errors.workAreaError}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Upload Files
                        </Form.Label>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </Box>
            </div>

            {/* Select File button */}
            <div className="form-inp col-sm-12">
              <input
                data-testid="file-upload-input"
                type="file"
                multiple
                onChange={handelSelectFiles}
                style={{
                  display: "none",
                }}
                id="file-upload-input"
              />
              <label htmlFor="file-upload-input">
                <Button
                  component="span"
                  style={{
                    textTransform: "none",
                    borderRadius: "0px",
                    backgroundColor: "var(--button-background-color)",
                    color: "var(--button-color)",
                    fontSize: "11px",
                    padding: "5px 12px",
                    border: "1px solid #144979",
                    margin: "-20px 15px 15px -5px",
                    whiteSpace: "white-space",
                    width: "160%",
                    height: "25px",
                  }}
                >
                  Select file(s)
                </Button>
              </label>
            </div>
            {/* Drag & Drop panle */}
            <div className="form-inp col-sm-12">
              <div
                {...getRootProps()}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "-5px",
                  border: "1px dashed #144979",
                  height: "100px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                <input {...getInputProps()} />
                <InputLabel
                  style={{
                    marginBottom: "5px",
                    fontWeight: 800,
                    fontSize: "11px",
                  }}
                >
                  Drop files here
                </InputLabel>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "20px",
                }}
              >
                {validationMessage && (
                  <Typography
                    color="error"
                    style={{ marginTop: "10px", color: "var(--text-color)" }}
                  >
                    {validationMessage}
                  </Typography>
                )}
              </div>
            </div>

            {/* Ag-Grid */}
            <div className="form-inp col-sm-12">
              <div
                className="ag-theme-quartz-dark"
                style={{
                  height: "20vh",
                  width: "100%",
                  marginTop: "10px",
                }}
              >
                <AgGridReact
                  rowData={rowData}
                  columnDefs={columnDef}
                  headerHeight={25}
                  gridOptions={{
                    rowSelection: {
                      mode: "multiRow",
                      checkboxes: true,
                      headerCheckbox: true,
                      enableClickSelection: false,
                    },
                  }}
                />
              </div>
            </div>
            {/* Action Button */}
            <div
              className="form-inp col-sm-12"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "10px",
                textAlign: "right",
              }}
            >
              <button
                className="preworksaveandsubmit-button"
                onClick={handelSaveAndSubmitClick}
                style={{ marginRight: "1em" }}
              >
                Save & Submit
              </button>
              <button
                className="preworksaveandsubmit-button"
                onClick={handleSaveAndAcceptClick}
                style={{ marginRight: "1em" }}
              >
                Save & Accept
              </button>
              <button className="preworkcancel-button" onClick={handelCancel}>
                Cancel
              </button>
            </div>
          </div>
        </Col>
      </Row>

      {/* Confirmation Dialog box */}
      <Dialog
        open={confirmDialogOpen}
        onClose={() => handleConfirmDialogClose(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle
          style={{
            backgroundColor: "var(--primary-color)",
            color: "var(--aggrid-text-color)",
            fontSize: "14px",
          }}
        >
          Upload
        </DialogTitle>
        <DialogContent style={{ fontSize: "14px", marginTop: "20px" }}>
          Are you sure you want to Cancel?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleConfirmDialogClose(true)}
            color="primary"
            style={{
              fontSize: "14px",
              height: "2.1em",
              padding: "4px 6px",
              border: "1px solid #144979",
            }}
          >
            Yes
          </Button>
          <Button
            onClick={() => handleConfirmDialogClose(false)}
            color="primary"
            style={{
              fontSize: "14px",
              height: "2.1em",
              padding: "4px 6px",
              border: "1px solid #144979",
            }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Upload;
